<!-- Modals -->
<app-deprecated-modal-form
    #editTaskModal
    headerText="{{ 'dashboard.editAndViewDetails' | translate }}"
    (save)="saveTask(currentTask)"
    (cancel)="onCancel()"
>
    <app-deprecated-task-form
        *ngIf="currentTask"
        #taskForm
        [employee]="currentTask.subject"
        [task]="currentTask"
    ></app-deprecated-task-form>
</app-deprecated-modal-form>

<!-- Body -->
<div id="task-viewer">
    <div class="task-container" #container [class.legacy]="legacy">
        <!-- Task Checklist-->
        <div class="tasks-container loadable" [class.loading]="isLoading" #tasksContainer>
            <ng-container>
                <app-task-checklist
                    #taskChecklist
                    [employee]="employee"
                    [onDashboard]="true"
                    [tasks]="tasks"
                    (updateTasks)="updateTasks()"
                    (onScroll)="onScroll()"
                    [showTaskId]="showTaskId"
                    [viewTaskDetailsAnalyticEvent]="viewTaskDetailsAnalyticEvent"
                    (deleted)="onDelete()"
                ></app-task-checklist>
            </ng-container>
        </div>

        <!--empty state -->
        <app-empty-state
            *ngIf="!tasks.length && !isLoading"
            [@fadeIn]
            label="{{ getEmptyStateMessage() | translate }}"
            src="/assets/illustrations/cup.png"
        ></app-empty-state>
    </div>
</div>
